/*

=========================================================
* Now UI Kit React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-kit-react
* Copyright 2020 Creative Tim (http://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-kit-react/blob/master/LICENSE.md)

* Designed by www.invisionapp.com Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import CacheRefresh from "components/CacheRefresh.jsx";
import configureStore from "store/configureStore";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.4.0";
import "assets/demo/demo.css?v=1.4.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.4.0";
// pages for this kit
import AdminLoginPage from "views/AdminLoginPage.js";
import AdminSignout from "views/AdminSignout.js";
import AdminSignupPage from "views/AdminSignupPage.js";
import AdminProfilePage from "views/AdminProfilePage.js";
import AdminChangePwd from "views/AdminChangePwd.js";
import AdminForgotPwd from "views/AdminForgotPassword.js";
import AdminResetPwd from "views/AdminResetPwd.js";
import AdminDeletePage from "views/AdminDeletePage.js";
import DonorConsent from "views/DonorConsent.js";
import LiquidLoveHome from "views/LiquidLoveHome.js";
import LiquidLoveDonorPage from "views/LiquidLoveDonorPage.js";
import PatientForm from "views/PatientForm.js";
import LiquidLoveDonors from "views/LiquidLoveDonors.js";
import AdminPatientDetails from "views/AdminPatientDetails.js";
import LiquidLoveRequests from "views/LiquidLoveRequests.js";
import UploadFile from "views/UploadFile.js";

const store = configureStore();
const root = createRoot(document.getElementById("root"));
  
root.render(
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LiquidLoveHome />} />
          <Route path="/index" element={<LiquidLoveHome />} />
          <Route path="/liquidlove/home" element={<LiquidLoveHome />} />        
          <Route path="/liquidlove/donor-consent" element={<DonorConsent />} />
          <Route path="/liquidlove/donor" element={<LiquidLoveDonorPage />} />
          <Route path="/liquidlove/donors" element={<LiquidLoveDonors />} />        
          <Route path="/liquidlove/import/donors" element={<UploadFile />} />
          <Route path="/liquidlove/patient" element={<PatientForm />} />
          <Route path="/liquidlove/patient-details" element={<AdminPatientDetails />} />
          <Route path="/liquidlove/requests" element={<LiquidLoveRequests />} />
          <Route path="/liquidlove/login" element={<AdminLoginPage />} />
          <Route path="/liquidlove/signout" element={<AdminSignout />} />
          <Route path="/liquidlove/register-admin" element={<AdminSignupPage />} />
          <Route path="/liquidlove/adminprofile" element={<AdminProfilePage />} />
          <Route path="/liquidlove/changepwd" element={<AdminChangePwd />} />
          <Route path="/liquidlove/forgot-pwd" element={<AdminForgotPwd />} />
          <Route path="/liquidlove/resetpwd" element={<AdminResetPwd />} />
          <Route path="/liquidlove/delete-admin" element={<AdminDeletePage />} />
        </Routes>
      </BrowserRouter>
    </Provider>
);
